import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminComponent } from './admin.component';
import { SettingComponent } from './setting/setting.component';
import { ViewLandRecordUpdatationComponent } from './view-landrecordupdatation/view-landrecordupdatation.component';
import { ViewCoapplicantsComponent } from './view-coapplicants/view-coapplicants.component';
import { ViewGuarantorComponent } from './view-guarantor/view-guarantor.component';
import { AdminAuthGuard } from './admin-auth-guard.service';
import { ViewDashboardComponent } from './view-dashboard/view-dashboard.component';
import { ViewMisComponent } from './view-mis/view-mis.component';
import { ViewConsentComponent } from './view-consent/view-consent.component';
import { ViewOfflineComponent } from './view-leadbox/lead-box.component';
import { ViewCustomerSubmittedComponent } from './view-customer-submitted/view-customer-submitted.component';
import { ViewCbsApprovedComponent } from './view-cbs-approved/view-cbs-approved.component';
import { AddUserComponent } from './add-user/add-user.component';
import { RenewalInboxComponent } from './renewal-inbox/renewal-inbox.component';
import { ViewUtilitiesComponent } from './view-utilities/view-utilities.component';
import { Landing1Component } from './landing1/landing1.component';
import { ScaleOfFinanceComponent } from './scale-of-finance/scale-of-finance.component';
import { StaleUsersReportComponent } from './stale-users-report/stale-users-report.component';


const routes: Routes = [
  {
    path: '', component: AdminComponent, children: [
      { path: 'view-landrecordupdatation', component: ViewLandRecordUpdatationComponent ,canActivate:[AdminAuthGuard]},
      { path: 'add-user', component: AddUserComponent ,canActivate:[AdminAuthGuard]},
      // { path: 'view-customer-submitted', component: ViewCustomerSubmittedComponent ,canActivate:[AdminAuthGuard]},
      { path: 'view-cbs-approved', component: ViewCbsApprovedComponent ,canActivate:[AdminAuthGuard]},
      { path: 'view-dashboard', component: ViewDashboardComponent ,canActivate:[AdminAuthGuard]},
      { path: 'mis', component: ViewMisComponent ,canActivate:[AdminAuthGuard]},
      { path: 'view-consent-pending', component: ViewConsentComponent ,canActivate:[AdminAuthGuard]},
      { path: 'view-consent-yes', component: ViewConsentComponent ,canActivate:[AdminAuthGuard]},
      { path: 'view-consent-no', component: ViewConsentComponent ,canActivate:[AdminAuthGuard]},
      { path: 'view-consent-dnr', component: ViewConsentComponent ,canActivate:[AdminAuthGuard]},
      // { path: 'leadbox', component: ViewOfflineComponent ,canActivate:[AdminAuthGuard]},
      { path: 'setting', component: SettingComponent,canActivate:[AdminAuthGuard] },
      // { path: 'view-coapplicants/:id', component: ViewCoapplicantsComponent,canActivate:[AdminAuthGuard] },
      // { path: 'view-guarantor/:id', component: ViewGuarantorComponent,canActivate:[AdminAuthGuard] },
      { path: 'renewal-success', component: RenewalInboxComponent ,canActivate:[AdminAuthGuard]},
      // { path: 'renewal-processing', component: RenewalInboxComponent ,canActivate:[AdminAuthGuard]},
      { path: 'renewal-failure', component: RenewalInboxComponent ,canActivate:[AdminAuthGuard]},
      { path: 'utilities', component: ViewUtilitiesComponent ,canActivate:[AdminAuthGuard]},
      { path: 'sof', component: ScaleOfFinanceComponent, canActivate:[AdminAuthGuard]},
      { path: 'landing1', component: Landing1Component ,canActivate:[AdminAuthGuard]},
      { path: 'stale-users-report', component: StaleUsersReportComponent, canActivate: [AdminAuthGuard] },
      { path: '', redirectTo: 'view-dashboard', pathMatch: 'full',canActivate:[AdminAuthGuard] },

    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
